import React from 'react';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import {Trans, useTranslation} from 'react-i18next';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {Typography} from '@mui/material';

interface DocumentSelectionWarningProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export const DocumentSelectionWarning: React.FC<
  DocumentSelectionWarningProps
> = ({isOpen, onClose, onProceed}) => {
  const {t} = useTranslation();
  if (!isOpen) return null;

  const modalFooter = (
    <div
      className="arr-placeholder-for-priv-docs-modal-footer"
      data-testid={`document-selection-warning-cancel-proceed`}>
      <ArrButton
        size="large"
        variant="secondary"
        onClick={onClose}
        dataTestId="document-selection-warning-cancel-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.cancel'
        )}
      </ArrButton>
      <ArrButton
        size="large"
        variant="primary"
        onClick={() => {
          onProceed();
          onClose();
        }}
        dataTestId="document-selection-warning-proceed-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.proceed'
        )}
      </ArrButton>
    </div>
  );
  return (
    <ArrModal
      headerTitle={t(
        'productionsAndExports.createNewProduction.privGuard.validationOnNext.documentsSelectionWarningModal.title'
      )}
      headerTitleClassName="headline3_size text-headings"
      showModal={isOpen}
      onClose={onClose}
      footer={modalFooter}
      dataTestId="documentdelectionwarning-modal"
    >
      <Typography
        component="div"
        className="typo-text body2_size desc-text-color"
        color="white"
        data-testid={`assignment-instructions`}
      >
        <Trans
          i18nKey="productionsAndExports.createNewProduction.privGuard.validationOnNext.documentsSelectionWarningModal.content"
          components={{
            br: <br data-testid={`document-selection-warning-br`} />,
            strong: <strong data-testid={`document-selection-warning-strong`} />,
            p: <p data-testid={`document-selection-warning-p`} />,
          }}
        />
      </Typography>
    </ArrModal>
  );
};
